import React, { useState, useEffect } from "react";
import Leftpanel from "../layout/Leftpanel";
import Header from "../layout/Header";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  getAllPastOrderDetailslist,
  getInvoiceBusinessUnitList,
  getInvoiceSupplierList,
} from "../../../service/PastOrder/PastOrderService";
import { format } from "date-fns";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import Select from "react-select";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getPastOrderById,
  getEditPastOrder,
} from "../../../service/PastOrder/PastOrderService";
import { getAllBusinesslist } from "../../../service/Department/DepartmentService";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Pastorderedit1 = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const pastOrderId = new URLSearchParams(location.search);
  console.log(pastOrderId.get(`id`), "pastOrderId");
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [selectedTime, setSelectedTime] = useState();
  const [getPastOrderId, setPastOrderId] = useState([]);
  const [getPastOrderCommentsId, setPastOrderCommentsId] = useState([]);
  const [businessList, setAllBusinessList] = useState([]);
  const [department, setDepartment] = useState([]);
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("");
  const [businessUnitNameId, setBusinessUnitNameId] = useState("");
  const [comments, setComments] = useState({
    commentk: "",
  });
  const [allData, setAllData] = useState({
    comments: "",
  });

  console.log(businessUnitNameId, "businessUnitNameId");
  useEffect(() => {
    getallPastOrderList();
  }, []);

  async function getallPastOrderList() {
    getPastOrderById(pastOrderId.get(`id`)).then(function (result) {
      const response = result.data;
      setPastOrderId(response?.data?.pastOrderDetails);
      setPastOrderCommentsId(response?.data?.pastOrderDetails?.CommentsLogs);
      const lastElement =
        response?.data?.pastOrderDetails?.CommentsLogs[
          response?.data?.pastOrderDetails?.CommentsLogs.length - 1
        ];
      setComments({ ...comments, commentk: lastElement?.comments });
      // setDepartmentId(response?.data?.businessUnit?.Departments);
    });
  }

  useEffect(() => {
    getBusinessUnitDataList();
    // console.log(lastElement?.comments)
  }, []);

  async function getBusinessUnitDataList() {
    getAllBusinesslist(search, department).then(function (result) {
      const response = result.data;
      setAllBusinessList(response.data);
    });
  }

  let businessUnitDropdown = <option>Loading...</option>;
  if (businessList && businessList.length > 0) {
    businessUnitDropdown = businessList.map((businessRow, index) => (
      <option value={businessRow.name}>{businessRow.name}</option>
    ));
  }

  const onBusinessUnitName = (e) => {
    setBusinessUnitNameId(e.target.value);
  };

  const onComments = (e) => {
    // setComments(e.target.value)
    setComments({ ...comments, commentk: e.target.value });
  };

  console.log(comments?.commentk, "alalalalalalala");

  const onUpdate = () => {
    getEditPastOrder(
      pastOrderId.get(`id`),
      businessUnitNameId
        ? businessUnitNameId
        : getPastOrderId?.Invoice?.invoice?.Invoice?.AccountingCustomerParty
            ?.Party?.PartyName?.Name?._text,
      comments?.commentk,
      getPastOrderId?.invoiceId,
      status ? status : getPastOrderId?.orderStatus,
      (r) => {
        console.log(r, "response");
        if (r.success === true) {
          toast.success(r.message);
          navigate("/pastorder");
        } else {
          console.log("nononononono");
          toast.error(r.message);
        }
      }
    );
  };

  const onStatus = (e) => {
    setStatus(e.target.value);
  };

  return (
    <div className="container-fluid">
      <div className="dbMain  pastorder">
        <Leftpanel />
        <div className="dbRight">
          <Header
            link="/pastorder"
            breadcm=""
            title="Past Order Edit"
            description=""
          />
          <div className="commonBase">
            <Form>
              <h6>Supplier / Vendor Details</h6>
              <Form.Group className="row" controlId="exampleForm.ControlInput1">
                <Col sm="6" className="mb-3">
                  <Form.Control
                    type="text"
                    placeholder="Supplier Name"
                    value={
                      getPastOrderId?.Invoice?.invoice?.Invoice
                        ?.AccountingSupplierParty?.Party?.PartyName?.Name?._text
                    }
                    readOnly
                  />
                </Col>
                <Col sm="6" className="mb-3">
                  <Form.Control
                    type="number"
                    placeholder="Phone Number"
                    value={
                      getPastOrderId?.Invoice?.invoice?.Invoice
                        ?.AccountingSupplierParty?.Party?.Contact?.Telephone
                        ?._text
                    }
                    readOnly
                  />
                </Col>
              </Form.Group>
              <Form.Group className="row" controlId="exampleForm.ControlInput1">
                <Col sm="6" className="mb-3">
                  <Form.Control
                    type="text"
                    placeholder="Website"
                    value="------"
                    readOnly
                  />
                </Col>
                <Col sm="6" className="mb-3">
                  <Form.Control
                    type="text"
                    placeholder="Department"
                    value={
                      getPastOrderId?.Invoice?.invoice?.Invoice
                        ?.AccountingSupplierParty?.Party?.Contact?.Name?._text
                    }
                    readOnly
                  />
                </Col>
              </Form.Group>
              <Form.Group className="row" controlId="exampleForm.ControlInput1">
                <Col sm="6" className="mb-3">
                  <Form.Control
                    type="text"
                    placeholder="Fax Number"
                    value="----"
                    readOnly
                  />
                </Col>
                <Col sm="6" className="mb-3">
                  <Form.Control
                    as="textarea"
                    rows={3}
                    placeholder="Address"
                    className="fixedHeight"
                    value={
                      getPastOrderId?.Invoice?.invoice?.Invoice
                        ?.AccountingSupplierParty?.Party?.PostalAddress
                        ?.StreetName?._text
                    }
                    readOnly
                  />
                </Col>
              </Form.Group>

              <h6 className="mt-3">Customer Details / Delivery information</h6>
              <Form.Group className="row" controlId="exampleForm.ControlInput1">
                <h5>
                  {businessUnitNameId
                    ? businessUnitNameId
                    : getPastOrderId?.Invoice?.invoice?.Invoice
                        ?.AccountingCustomerParty?.Party?.PartyName?.Name
                        ?._text}
                </h5>
                <Col sm="6" className="mb-3">
                  <Form.Select
                    className="form-control"
                    aria-label="Default select example"
                    readOnly
                    onChange={onBusinessUnitName}
                  >
                    <option selected>Select Operator unit</option>
                    {businessUnitDropdown}
                  </Form.Select>
                </Col>
                <Col sm="6" className="mb-3">
                  <Form.Control
                    type="number"
                    placeholder="Phone Number"
                    value={0}
                    readOnly
                  />
                </Col>
              </Form.Group>
              <Form.Group className="row" controlId="exampleForm.ControlInput1">
                <Col sm="6" className="mb-3">
                  <Form.Control
                    type="text"
                    placeholder="Company Name"
                    value={
                      getPastOrderId?.Invoice?.invoice?.Invoice
                        ?.AccountingCustomerParty?.Party?.PartyLegalEntity
                        ?.RegistrationName?._text
                    }
                    readOnly
                  />
                </Col>
                <Col sm="6" className="mb-3">
                  <Form.Control
                    as="textarea"
                    rows={3}
                    placeholder="Address"
                    className="fixedHeight"
                    value={
                      getPastOrderId?.Invoice?.invoice?.Invoice
                        ?.AccountingCustomerParty?.Party?.PostalAddress
                        ?.StreetName?._text
                    }
                    readOnly
                  />
                </Col>
              </Form.Group>
              <Form.Group className="row" controlId="exampleForm.ControlInput1">
                <Col sm="6" className="mb-3">
                  <Form.Control
                    type="email"
                    placeholder="Email Address"
                    value="----"
                    readOnly
                  />
                </Col>
                <Col sm="6" className="mb-3">
                  <div className="dateSelect delDate">
                    <DatePicker
                      selectsStart
                      selected={startDate}
                      onChange={(date) => setStartDate(date)}
                      startDate={startDate}
                      placeholderText="Delivery Date"
                      value={
                        getPastOrderId?.Invoice?.invoice?.Invoice?.DueDate
                          ?._text
                      }
                    />
                    {/* <DatePicker
                                            selectsEnd
                                            selected={endDate}
                                            onChange={date => setEndDate(date)}
                                            endDate={endDate}
                                            startDate={startDate}
                                            minDate={startDate}
                                            placeholderText="To"
                                        /> */}
                  </div>
                </Col>
              </Form.Group>

              <Form.Group className="row" controlId="exampleForm.ControlInput1">
                <Col sm="6" className="mb-3" readOnly>
                  <div className="dateSelect delTime">
                    <DatePicker
                      readOnly
                      selected={selectedTime}
                      onChange={(date) => setSelectedTime(date)}
                      showTimeSelect
                      showTimeSelectOnly
                      timeIntervals={15}
                      timeCaption="Time"
                      dateFormat="h:mm aa"
                      placeholderText="Delivery Time"
                    />
                  </div>
                </Col>
              </Form.Group>

              <h6 className="mt-3">Order Details</h6>
              <Form.Group className="row" controlId="exampleForm.ControlInput1">
                <Col sm="6" className="mb-3">
                  <Form.Control
                    type="text"
                    placeholder="Order Id"
                    value={
                      getPastOrderId?.Invoice?.invoice?.Invoice?.OrderReference
                        ?.ID?._text
                    }
                    readOnly
                  />
                </Col>
                <Col sm="6" className="mb-3">
                  <Form.Control
                    type="text"
                    placeholder="Invoice Id"
                    value={getPastOrderId?.Invoice?.invoice?.Invoice?.ID?._text}
                    readOnly
                  />
                </Col>
              </Form.Group>
              <Form.Group className="row" controlId="exampleForm.ControlInput1">
                <Col sm="6" className="mb-3">
                  <Form.Select
                    className="form-control"
                    aria-label="Default select example"
                    onChange={onStatus}
                  >
                    <option selected hidden>
                      {getPastOrderId?.orderStatus}
                    </option>
                    <option value="Order Created">Order Created</option>
                    <option value="Order Received">Order Received</option>
                    <option value="Received without comment">
                      Received without comment
                    </option>
                    <option value="Received with comment">
                      Received with comment
                    </option>
                    <option value="Order Approved">Order Approved</option>
                    <option value="Order Cancelled">Order Cancelled</option>
                  </Form.Select>
                </Col>
              </Form.Group>

              <h6 className="mt-3">Product Details</h6>
              {getPastOrderId?.Invoice?.invoice?.Invoice?.InvoiceLine?.map(
                (d, i) => (
                  <>
                    <label>{i + 1}.</label>
                    <Form.Group
                      className="row"
                      controlId="exampleForm.ControlInput1"
                    >
                      <Col sm="6" className="mb-3">
                        <Form.Control
                          type="text"
                          placeholder="Item"
                          value={d?.Item?.SellersItemIdentification?.ID?._text}
                          readOnly
                        />
                      </Col>
                      <Col sm="6" className="mb-3">
                        <Form.Control
                          as="textarea"
                          rows={3}
                          placeholder="Description"
                          className="fixedHeight"
                          value={d?.Item?.Name?._text}
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                    <Form.Group
                      className="row"
                      controlId="exampleForm.ControlInput1"
                    >
                      <Col sm="6" className="mb-3">
                        <Form.Control
                          type="number"
                          placeholder="Quantity"
                          value={d?.InvoicedQuantity?._text}
                          readOnly
                        />
                      </Col>
                      <Col sm="6" className="mb-3">
                        <Form.Control
                          type="number"
                          placeholder="Carbon footprint"
                          value="----"
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                    <Form.Group
                      className="row"
                      controlId="exampleForm.ControlInput1"
                    >
                      <Col sm="6" className="mb-3">
                        <Form.Control
                          type="number"
                          placeholder="Unit Price"
                          value={Number(d?.Price?.PriceAmount?._text).toFixed(
                            2
                          )}
                          readOnly
                        />
                      </Col>
                      <Col sm="6" className="mb-3">
                        <Form.Control
                          type="number"
                          placeholder="Discount"
                          value=""
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </>
                )
              )}

              <Form.Group className="row" controlId="exampleForm.ControlInput1">
                <Col sm="6" className="mb-3">
                  <Form.Control
                    type="number"
                    placeholder="Total"
                    readOnly
                    value={Number(
                      (Number(
                        getPastOrderId?.Invoice?.invoice?.Invoice
                          ?.LegalMonetaryTotal?.LineExtensionAmount?._text
                      ) *
                        Number(
                          getPastOrderId?.Invoice?.invoice?.Invoice?.TaxTotal
                            ?.TaxSubtotal?.TaxCategory?.Percent?._text
                        )) /
                        100 +
                        Number(
                          getPastOrderId?.Invoice?.invoice?.Invoice
                            ?.LegalMonetaryTotal?.LineExtensionAmount?._text
                        )
                    ).toFixed(2)}
                  />
                </Col>
                <Col sm="6" className="mb-3">
                  <Form.Control
                    type="number"
                    placeholder="Sub Total"
                    readOnly
                    value={
                      getPastOrderId?.Invoice?.invoice?.Invoice
                        ?.LegalMonetaryTotal?.LineExtensionAmount?._text
                    }
                  />
                </Col>
              </Form.Group>
              <Form.Group className="row" controlId="exampleForm.ControlInput1">
                <Col sm="6" className="mb-3">
                  <Form.Control
                    type="number"
                    placeholder="Shipping Charge"
                    readOnly
                  />
                </Col>
                <Col sm="6" className="mb-3">
                  <Form.Control
                    type="number"
                    placeholder="Other Price"
                    readOnly
                  />
                </Col>
              </Form.Group>
              <Form.Group className="row" controlId="exampleForm.ControlInput1">
                <Col sm="6" className="mb-3">
                  <Form.Control
                    type="text"
                    placeholder="Grand Total"
                    readOnly
                  />
                </Col>
                <Col sm="6" className="mb-3">
                  <Form.Control
                    as="textarea"
                    rows={3}
                    placeholder="Comments & special instructions"
                    className="fixedHeight"
                    name="comments"
                    value={comments?.commentk}
                    onChange={onComments}
                  />
                </Col>
              </Form.Group>

              <button type="button" className="commonButton" onClick={onUpdate}>
                Save
              </button>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Pastorderedit1;
